import InlineCard from '../primitives/InlineCard';
import InlineCardEmpty from '../primitives/InlineCardEmpty';
import { buildCardModel } from '../lib/buildCardModel';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import type { VisualProps, VisualWidget } from '../types';

/** `brand_inline_card` — self overview of a single brand. */
const BrandInlineCard = ({ output, Frame, showEmptyState }: VisualProps) => {
    const model = buildCardModel(output, 'Brand');
    if (!model) {
        return showEmptyState ? (
            <InlineCardEmpty
                breadcrumb={buildBreadcrumb(output, 'Brand')}
                typeLabel="Brand"
                Frame={Frame}
            />
        ) : null;
    }
    return <InlineCard {...model} Frame={Frame} />;
};

const widget: VisualWidget = {
    match: (input) =>
        input?.entity_type === 'brand' && input?.entity_relationship === 'self',
    Component: BrandInlineCard,
};

export default widget;
